import axios from 'axios';
import { availableCategories } from '../Services/getCategories';

export const createInstitution = async (
	name,
	institutionType,
	code,
	domain,
	logo,
	categories,
	activateModal,
	requestLoginInstitution,
	uniqueLoginInstitution,
	uniqueUser,
	uniqueUserPass,
	setLoading,
	setMessageCreation,
	resourceCategories
) => {
	const formData = new FormData();
	formData.append('name', name);

	if (institutionType.length > 0) {
		formData.append('institutionType', JSON.stringify(institutionType));
	} else {
		activateModal('Debes seleccionar al menos un tipo de institución');
		return; // Detener la ejecución
	}

	if (resourceCategories.length <= 0) {
		activateModal('Debes seleccionar al menos una categoría de recursos');
		return;
	}

	formData.append('code', code);
	formData.append('domain', domain);

	if (logo) {
		formData.append('logo', logo);
	} else {
		activateModal('Debes agregar el logo de la institución');
		return; // Detener la ejecución
	}
	// Verifica que hayan categorías seleccionadas
	if (categories.length > 0) {
		categories.forEach((category, i) => {
			const selectedCategory = availableCategories.find(
				(cat) => cat.name === category
			);
			if (selectedCategory) {
				formData.append(`category${i}`, JSON.stringify(selectedCategory));
			}
		});
	} else {
		activateModal('Debes seleccionar al menos una categoría de institución');
		return; // Detener la ejecución
	}

	formData.append('requestLoginInstitution', requestLoginInstitution);
	formData.append('uniqueLoginInstitution', uniqueLoginInstitution);

	formData.append('user', uniqueUser);
	formData.append('pass', uniqueUserPass);
	formData.append('resourcesCategories', JSON.stringify(resourceCategories));
	// Log the FormData items
	// for (let [key, value] of formData.entries()) {
	// 	console.log(key, value);
	// }

	try {
		setLoading(true);
		const response = await axios.post('/institutions/v2', formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
				Authorization: `Bearer ${localStorage.token}`,
			},
		});
		if (response.status === 201) {
			setLoading(false);
			setMessageCreation(
				`La institución ${name} fue creada satisfactoriamente.`
			);
			setTimeout(() => {
				setMessageCreation('');
			}, 5000);
		}
	} catch (error) {
		console.error(error);
		setLoading(false);
		setMessageCreation('Hubo un problema en la creación de la institución.');
		setTimeout(() => {
			setMessageCreation('');
		}, 5000);
	}
};
